var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalyticsOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52 19.97c-0.331 0-0.6-0.269-0.6-0.6s0.269-0.6 0.6-0.6h0.6v-7.2c0-0.662 0.538-1.2 1.2-1.2h2.4c0.662 0 1.2 0.538 1.2 1.2v7.2h1.2v-14.4c0-0.662 0.538-1.2 1.2-1.2h2.4c0.662 0 1.2 0.538 1.2 1.2v14.4h1.2v-10.8c0-0.662 0.538-1.2 1.2-1.2h2.4c0.662 0 1.2 0.538 1.2 1.2v10.8h0.6c0.331 0 0.6 0.269 0.6 0.6s-0.269 0.6-0.6 0.6h-18zM18.72 18.77v-10.8h-2.4v10.8h2.4zM12.72 18.77v-14.4h-2.4v14.4h2.4zM6.72 18.77v-7.2h-2.4v7.2h2.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsOutline);
export default __webpack_public_path__ + "static/media/AnalyticsOutline.49dc937b512a51d46493aae6651e971f.svg";
export { ForwardRef as ReactComponent };